module.exports = __webpack_public_path__ + "static/media/prishalogo.74af73e5.jpg";